import { render, staticRenderFns } from "./base-office.vue?vue&type=template&id=490d3538&"
import script from "./base-office.vue?vue&type=script&lang=js&"
export * from "./base-office.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('490d3538')) {
      api.createRecord('490d3538', component.options)
    } else {
      api.reload('490d3538', component.options)
    }
    module.hot.accept("./base-office.vue?vue&type=template&id=490d3538&", function () {
      api.rerender('490d3538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/base-office.vue"
export default component.exports